import { StyleEntry } from 'Shared/backend/styleUtils';
import { textSection } from 'Shared/backend/settingsPage/frontendSettingsTree';

//TODO? structure as a category tree if the concept appears to work. This should allow names to be scoped within their categories and subcategories...

/*
	One style per globally-configured text type - Page title, Title, Teaser, Tagline, Subtitle, Plain
	text. The list is read straight off the 'Text' settings section (SettingsPage) so the two stay in
	step and a venue could later add its own. Each style restyles a title component in the subtree it
	is applied to with that text type's resolved css.
*/
export function textStyles(sizes,text): {[name: string]: StyleEntry}
{
	const result: {[name: string]: StyleEntry} = {};

	for (const branch of textSection.branches)
		result[branch.label] = {
			explanation: `Converts a title to ${branch.label.toLowerCase()}.`,
			rules: [{
				location: () => ['text:title'],
				css: () => text[branch.field],
			}],
		};

	/* The event page's date and name headings default to the 'Page title' text style
	   (BaseSettings.siteTheme()); this restyles them with 'Title' instead. Unlike the entries above -
	   which target a Text widget's own title - it lands on the page's top-level heading, the class
	   'title' element straight under the page root, so it stays clear of the lineup artist names,
	   which carry the same class further down. Turned on through the Event page's Styles control. */
	result['Use Title as Page title'] = {
		explanation: 'Styles the page heading with the Title text style instead of Page title.',
		rules: [{
			location: () => ['^','*:title'],
			css: () => text.title,
		}],
	};

	return result;
}
